/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import MonitoringInfoBiddingModal from 'components/molecules/monitoring_info_bidding_modal';
import {
  BiddingTypes,
  MonitoredByCompanyTypes,
  MonitoredByTypes,
  MonitoringRequestTypes,
} from 'store/modules/monitoring_store/types';
import MonitoringCompanyActionModal from 'components/molecules/monitoring_company_action_modal';
import { asksCompany, CompanyAction, ownCompanies } from 'services/monitoring_companies';

import createTrack from 'services/actions/tracker_actions';
import { useDispatch, useSelector } from 'react-redux';
import {
  archive,
  destroyElectronicsTradings,
  markAsRead,
  toggleImportant,
} from 'store/modules/monitoring_store/actions';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { getComments } from 'store/modules/bidding_store/actions';
import companyId from 'services/company_id';
import { createMonitoreBidding } from 'services/actions/monitore_actions';
import { Container } from './styles';
import DropdownActionItem from '../dropdown_action_item';
import ModalNotes from '../modal_notes';

interface TradingDropdownProps {
  isVisible?: boolean;
  bidding: BiddingTypes;
  archived: boolean;
  important: boolean;
  lots: boolean;
  id: number;
  monitoredBy?: Array<MonitoredByTypes>;
  companies?: Array<MonitoredByCompanyTypes>;
  onCompaniesChanged?: () => void;
}

const TradingDropdown = ({
  isVisible,
  bidding,
  archived,
  important,
  lots,
  id,
  monitoredBy,
  companies,
  onCompaniesChanged,
}: TradingDropdownProps) => {
  const dispatch = useDispatch();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const multi = asksCompany(companies);
  const [companyAction, setCompanyAction] = useState<CompanyAction | null>(null);

  const isCurrentUserMonitoring = monitoredBy?.some((m) => m.id === profile.id) ?? true;

  const currentUserMonitor: MonitoredByTypes = {
    id: profile.id,
    nome: profile.name,
    acronym_name:
      profile.name
        ?.split(' ')
        .map((n: string) => n[0])
        .join('')
        .slice(0, 2) || '',
  };

  const stop = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const [modalMonitoringInfoBiddingOpened, setModalMonitoringInfoBiddingOpened] =
    useState<boolean>(false);
  const [modalNote, setModalNote] = useState<boolean>(false);

  return (
    <Container className={`dropdown ${isVisible ? 'force-visible' : ''}`}>
      <button
        type="button"
        className="trading-toggle d-flex"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={stop}
      >
        <i className="material-icons p-0">keyboard_arrow_down</i>
      </button>

      <div className="dropdown-menu dropdown-menu-right">
        {lots && (
          <DropdownActionItem
            onClick={() => {
              if (multi) {
                ownCompanies(companies).forEach((company) =>
                  dispatch(markAsRead(id, null, company.id)),
                );
              } else {
                dispatch(markAsRead(id, null, companyId(profile)));
              }
              createTrack('Monitorar Chat - Marcar como lido');
            }}
          >
            Marcar como lido
          </DropdownActionItem>
        )}
        {multi && (
          <DropdownActionItem className="rounded-top" onClick={() => setCompanyAction('important')}>
            Importante
          </DropdownActionItem>
        )}
        {!multi && !archived && isCurrentUserMonitoring && (
          <DropdownActionItem
            className="rounded-top"
            onClick={() => {
              dispatch(toggleImportant(bidding?.id, companyId(profile)));

              important
                ? createTrack('Monitorar Chat - Removeu dos Importantes', {
                    bidding: bidding?.id,
                  })
                : createTrack('Monitorar Chat - Marcou como importante', {
                    bidding: bidding?.id,
                  });
            }}
          >
            {important ? 'Remover dos Importantes' : 'Marcar como importante'}
          </DropdownActionItem>
        )}
        <DropdownActionItem
          onClick={() => {
            setModalMonitoringInfoBiddingOpened(true);
            createTrack('Monitorar Chat - Informações da Licitação');
          }}
        >
          Informações da Licitação
        </DropdownActionItem>
        <button
          type="button"
          className="dropdown-item p-3 rounded-top"
          data-toggle="modal"
          data-target="#monitoring-modal"
          onClick={() => {
            setModalNote(true);
            dispatch(getComments(String(bidding?.id)));
            createTrack('Monitorar Chat - abriu as anotações');
          }}
        >
          Anotações
        </button>
        {multi && (
          <DropdownActionItem onClick={() => setCompanyAction('archive')}>
            Arquivar ou desarquivar
          </DropdownActionItem>
        )}
        {!multi && isCurrentUserMonitoring && (
          <DropdownActionItem
            onClick={() => {
              dispatch(archive(bidding?.id, companyId(profile), profile?.id));

              archived
                ? createTrack('Monitorar Chat - Desarquivou a licitação', {
                    bidding: bidding?.id,
                  })
                : createTrack('Monitorar Chat - Arquivou a licitação', {
                    bidding: bidding?.id,
                  });
            }}
          >
            {archived ? 'Desarquivar' : 'Arquivar pregão'}
          </DropdownActionItem>
        )}
        {multi && (
          <button
            type="button"
            className="dropdown-item border-top p-3 rounded-bottom"
            onClick={() => setCompanyAction('unmonitor')}
          >
            Desativar monitoramento
          </button>
        )}
        {!multi && isCurrentUserMonitoring && (
          <button
            type="button"
            className="dropdown-item border-top p-3 rounded-bottom"
            onClick={() => {
              dispatch(destroyElectronicsTradings(bidding?.id, companyId(profile)));
              dispatch({
                type: MonitoringRequestTypes.REMOVE_MONITORED_BY,
                biddingId: bidding?.id,
                monitor: currentUserMonitor,
              });
            }}
          >
            Desativar monitoramento
          </button>
        )}
        {!multi && !isCurrentUserMonitoring && (
          <button
            type="button"
            className="dropdown-item border-top p-3 rounded-bottom"
            onClick={async () => {
              await createMonitoreBidding({
                biddingId: bidding?.id,
                setIsLoading: () => {},
                setMonitored: () => {},
                companyId: companyId(profile),
              });
              dispatch({
                type: MonitoringRequestTypes.ADD_MONITORED_BY,
                biddingId: bidding?.id,
                monitor: currentUserMonitor,
              });
            }}
          >
            Ativar monitoramento de chat
          </button>
        )}
      </div>
      <MonitoringInfoBiddingModal
        modalMonitoringInfoBiddingOpened={modalMonitoringInfoBiddingOpened}
        setModalMonitoringInfoBiddingOpened={setModalMonitoringInfoBiddingOpened}
        bidding={bidding}
      />
      <ModalNotes modalNote={modalNote} setModalNote={setModalNote} bidding_id={bidding?.id} />
      <MonitoringCompanyActionModal
        action={companyAction}
        biddingId={bidding?.id}
        edital={bidding?.edital}
        companies={companies}
        onClose={() => setCompanyAction(null)}
        onDone={() => onCompaniesChanged?.()}
      />
    </Container>
  );
};

export default TradingDropdown;
